function preload(){

  bus.emit('pageEnter')
  return

  
  let tl = gsap.timeline()
  tl.pause()

  const $prld   = $('.prld')
  const delay = 1.6

  // anim
  tl.to($('.prld'), 1.6, {autoAlpha:0, ease:'power3.out'}, delay + 1)


  // init
  tl.add(function(){
    bus.emit('pageEnter')
  }, 1.1 + 1)

  // remove DOM element
  tl.add(function(){
    $prld.remove()
  })


  if (window.preloader === "fast") {
    gsap.to(tl, 3, {progress:1})
  } else if (window.preloader === false) {
    gsap.to(tl, .1, {progress:1})
  } else if (typeof window.preloader === 'number') {
    gsap.to(tl, window.preloader, {progress:1})
  } else {
    tl.play()
  }
}

export default preload